import React from "react";
import DLRdmvLogo from "assets/img/DLRdmv.png";

// Define the Manheim component
const DLRdmv = () => {
	// Function to open the OFAC search URL in a new tab securely
	const openInNewTab = () => {
		const newWindow = window.open(
			"https://www.dlrdmv.com/out-of-state/",
			"_blank",
			"noopener,noreferrer"
		);
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div
			onClick={openInNewTab}
			style={{ width: "150px", height: "70px", overflow: "hidden" }}
		>
			<img src={DLRdmvLogo} alt="J.D. POWER" style={{ cursor: "pointer" }} />{" "}
		</div>
	);
};

export default DLRdmv;
